import _createClass from "/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _callSuper from "/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/inherits.js";
/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module font/fontbackgroundcolor/fontbackgroundcolorcommand
 */

import FontCommand from '../fontcommand';
import { FONT_BACKGROUND_COLOR } from '../utils';

/**
 * The font background color command. It is used by
 * {@link module:font/fontbackgroundcolor/fontbackgroundcolorediting~FontBackgroundColorEditing}
 * to apply the font background color.
 *
 *		editor.execute( 'fontBackgroundColor', { value: 'rgb(250, 20, 20)' } );
 *
 * **Note**: Executing the command with the `null` value removes the attribute from the model.
 *
 * @extends module:font/fontcommand~FontCommand
 */
var FontBackgroundColorCommand = /*#__PURE__*/function (_FontCommand) {
  /**
   * @inheritDoc
   */
  function FontBackgroundColorCommand(editor) {
    _classCallCheck(this, FontBackgroundColorCommand);
    return _callSuper(this, FontBackgroundColorCommand, [editor, FONT_BACKGROUND_COLOR]);
  }
  _inherits(FontBackgroundColorCommand, _FontCommand);
  return _createClass(FontBackgroundColorCommand);
}(FontCommand);
export { FontBackgroundColorCommand as default };